import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=42411842&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=42411842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42411842",
  null
  
)

export default component.exports